"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(Component) {
  return (0, _recompose.getContext)({
    components: _propTypes["default"].shape({}),
    partials: _propTypes["default"].shape({}),
    sections: _propTypes["default"].array,
    theme: _propTypes["default"].shape({})
  })(Component);
};

exports["default"] = _default;